import styled from '@emotion/styled'

export const TextWrapper = styled.div``
